module.exports = __webpack_public_path__ + "static/media/20190916-join-pc.e699bbd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/20190916-join-pc.jpg
// module id = 210
// module chunks = 0